import React, { Fragment } from 'react';
import { Field } from 'formik';
import styled, { css } from 'styled-components';
import { emy, fontUbuntu, fontUbuntuLight } from '../../utilities/utilities';

// import InputField from '../../collections/FormInputField/FormInputField';
// import Input from '../../collections/FormInput/FormInput';
// import Label from '../../collections/FromLabel/FormLabel';
import Error from '../Form/FormError';

const CheckboxInput = ({ name, label, link, url, textColor, ...rest }) => (
  <Field
    name={name}
    render={({ field, form }) => {
      let error = undefined;
      const valid = form.errors[name] === undefined && form.initialValues[name] !== form.values[name]
      
      if (form.touched[name]) {
        error = form.errors[name] !== undefined
      } else {
        error = form.errors[name] !== undefined && form.initialValues[name] !== form.values[name]
      }

      return (
        <Fragment>
          <CheckboxInputField>
            <Checkbox id={name} type="checkbox" error={error} valid={valid} {...field} {...rest} />
            <CheckboxLabel textColor={textColor} fontFamily={fontUbuntuLight} htmlFor={name}>{label}{link && (<Link href={`${url === '/' ? '' : url}/terms`} target="_blank" >{link}</Link>)}</CheckboxLabel>
          </CheckboxInputField>
          {error && (
            <Error>{form.errors[name]}</Error>
          )}
        </Fragment>
      );
    }}
  />
);

const Link = styled.a`
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
`;

const CheckboxInputField = styled.div`
  display: flex;
  position: relative;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  padding: 1rem 0 0.5rem 0;
  justify-content: center;
  font-size: 1rem;

  ${props => props.optin && css`
    background-color: #f7f7f7;
    width: 100%;
    border: 1px solid #ddd;
  `}
`

const Checkbox = styled.input`
  /* transform: scale(1.5); */
  min-height: 1rem;
  min-width: 1rem;
  cursor: pointer;
`;

const CheckboxLabel = styled.label`
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
  color: ${props => props.textColor ? props.textColor : '#0d1b58'};
  font-size: ${emy(13.64)};
  margin: 0 1rem;
  font-weight: 500;
  text-rendering: optimizeLegibility;
  cursor: pointer;
`;

export default CheckboxInput;


// WEBPACK FOOTER //
// ./src/components/Form/CheckboxInput.js